import { IMigration } from './migration';
// import { StandardizedServicesMigration } from "./20180120-standardized-services.migration";
// import { FlattenMatchMigration } from "./20180129-flatten-match.migration";

export const migrations: any[] = [
  /*StandardizedServicesMigration
  FlattenMatchMigration*/
];

// export * from "./20180120-standardized-services.migration";
// export * from "./20180129-flatten-match.migration";
